import { useDispatch, useSelector } from 'dva';
import { useEffect, useCallback, useState } from 'react';
import { isEmptyObject } from '@/utils/comUtil';
import styles from './approvalList.less?modules';
import { useUpdateEffect } from '@umijs/hooks';
const ApprovalList = (props) => {
  const { diagramName } = props || {};
  const dispatch = useDispatch();

  const bizData = useSelector((state) => state.dvm.approvalList);
  // const [diagramName, setDiagramName] = useState(undefined);
  const [diagramNameOption, setDiagramNameOption] = useState({});
  const [seledDiagramNameOption, setSeledDiagramNameOption] = useState({});
  const getApprovalList = useCallback(() => {
    dispatch({
      type: 'dvm/getApprovalList',
    });
  }, [dispatch]);
  useEffect(() => {
    getApprovalList();
  }, [getApprovalList]);
  useEffect(() => {
    if (!bizData) {
      return;
    }
    let obj = {};
    bizData &&
      bizData.length > 0 &&
      bizData.map((item) => (obj[item.diagramName] = item.diagramName));
    setDiagramNameOption(obj);
  }, [bizData]);
  useEffect(() => {
    if (isEmptyObject(diagramNameOption)) {
      return;
    }
    // setDiagramName(bizData[0].diagramName);
  }, [bizData, diagramNameOption]);
  useUpdateEffect(() => {
    setSeledDiagramNameOption(
      bizData.filter((item) => {
        return item.diagramName === diagramName;
      })[0],
    );
  }, [diagramName]);
  return (
    <>
      <ul className={styles.ul}>
        <li className={styles.li}>
          {/* <div className={styles.single_info}>
            <SelectML
              height="37px"
              inputWidth="180px"
              labelwidth="130px"
              labelVal="决策图名称"
              placeVal="请选择决策图名称"
              value={diagramName}
              option={toOption(diagramNameOption, true)}
              onSelect={(val) => setDiagramName(val)}
            />
          </div> */}
          <div className={styles.single_info}>
            当前线上版本：{seledDiagramNameOption.onlineVersion}
          </div>
          <div className={styles.single_info}>
            上个版本：{seledDiagramNameOption.previousVersion}
          </div>
          <div className={styles.single_info}>
            当前配置版本：{seledDiagramNameOption.currentVersion}
          </div>
        </li>
      </ul>
    </>
  );
};
export default ApprovalList;
